import { Box, styled } from "@mui/material";
import React from "react";
import { Button } from "../../Button/Button";
import { Chip } from "../../Chip/Chip";
import { RefinerGroupType, getDateRangeRefinerGroups, getListRefinerGroups } from "../../Refiner/RefinerGroup";
import { getRefinerOptionKey } from "../types/CellValue";
const classes = {
    outlinedPrimary: "refinerSummary-outlinedPrimary",
    deleteIcon: "refinerSummary-deleteIcon",
    container: "refinerSummary-container",
    chip: "refinerSummary-chip",
    label: "refinerSummary-label",
    text: "refinerSummary-text",
    clearAll: "refinerSummary-clearAll"
};
const StyledBox = styled(Box)(({ theme }) => ({
    [`& .${classes.outlinedPrimary}`]: {
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "16px",
        color: theme.palette.text.secondary
    },
    [`& .${classes.deleteIcon}`]: {
        width: "20px",
        height: "20px"
    },
    [`&.${classes.container}`]: {
        minHeight: "55px",
        display: "flex",
        alignContent: "center",
        width: "100%",
        flexWrap: "wrap",
        padding: "5px"
    },
    [`& .${classes.chip}`]: {
        margin: "5px"
    },
    [`& .${classes.label}`]: {
        color: theme.palette.text.secondary
    },
    [`& .${classes.text}`]: {
        color: theme.palette.text.primary
    },
    [`& .${classes.clearAll}`]: {
        padding: "4px 16px"
    }
}));
/**
 * Refiner control
 * @param props @see AppliedRefinerSummaryProps
 */
export const AppliedRefinerSummary = ({ appliedRefiners, onDelete, onClearAll, className }) => {
    const classNames = `${classes.container} ${className ?? ""}`;
    const getListRefinerOptionChipElements = (refinerGroup) => {
        return refinerGroup.refinerOptions.map((refiner) => {
            if (refiner.isSelected) {
                return (React.createElement(Chip, { text: React.createElement("span", { className: classes.label },
                        `${refinerGroup.name}: `,
                        React.createElement("b", { className: classes.text }, refiner.value?.toString() ?? "-")), onDelete: () => onDelete(RefinerGroupType.ListRefiner, refinerGroup.path, { refinerOption: refiner }), variant: "primary", key: `${refinerGroup.name}.${getRefinerOptionKey(refiner.value)}`, className: `${classes.chip}` }));
            }
            else
                return null;
        });
    };
    const getDateRangeRefinerChipElement = (refinerGroup) => {
        if (refinerGroup.dateRange?.fromDate || refinerGroup.dateRange?.toDate) {
            const text = `${refinerGroup.dateRange.fromDate?.toLocaleDateString() || ""} - ${refinerGroup.dateRange.toDate?.toLocaleDateString() || ""}`;
            return (React.createElement(Chip, { text: React.createElement("span", { className: classes.label },
                    `${refinerGroup.name}: `,
                    React.createElement("b", { className: classes.text }, text)), onDelete: () => onDelete(RefinerGroupType.DateRange, refinerGroup.path, { refinerOption: refinerGroup.dateRange }), variant: "primary", key: `${refinerGroup.name}.${refinerGroup.path}`, className: `${classes.chip}` }));
        }
        return null;
    };
    return (React.createElement(StyledBox, { className: classNames },
        appliedRefiners.map((refinerGroup) => {
            switch (refinerGroup.refinerGroupType) {
                case RefinerGroupType.ListRefiner:
                    return getListRefinerOptionChipElements(refinerGroup);
                case RefinerGroupType.DateRange:
                    return getDateRangeRefinerChipElement(refinerGroup);
            }
        }),
        (getListRefinerGroups(appliedRefiners).find((refinerGroup) => refinerGroup.refinerOptions.find((refiner) => refiner.isSelected)) ||
            getDateRangeRefinerGroups(appliedRefiners).find((r) => r.dateRange && (r.dateRange.fromDate || r.dateRange.toDate))) && (React.createElement(Button, { rounded: true, text: "Clear All", onClick: onClearAll, size: "medium", className: `clear-all ${classes.chip} ${classes.clearAll}` }))));
};
